import React, { Component } from 'react';
import { Icon } from 'react-fa';
import pick from 'lodash/pick';
import { Provider } from 'react-redux';
import { actions } from 'react-redux-form';

import store from './store';
import styles from './App.css';

import formStyles from '../form/Form.css';
import LoadingModal from '../LoadingModal';
import { getAmountInCents } from '../../shared/emoluments';
import ActForm from '../act/ActForm';

import logo from '../resources/logo.jpg';

const { WH_API_URL } = process.env;

const stripeHandler = StripeCheckout.configure({
  key: global.__TEST__ ?
    process.env.WH_STRIPE_PUBLISHABLE_KEY_TEST :
    process.env.WH_STRIPE_PUBLISHABLE_KEY,
  locale: 'auto',
  name: 'WARDWELL & HAMILTON',
  image: logo,
  description: 'Paiement',
  zipCode: true,
  currency: 'eur',
});

const initialState = {
  showLoading: false,
  showSuccess: false,
};

export default class App extends Component {

  constructor() {
    super();

    this.state = initialState;
  }

  onSubmit = value => {
    stripeHandler.open({
      amount: getAmountInCents(value.contractValue),
      token: this.onToken.bind(null, value),
    });
  }

  onToken = (value, token) => {
    this.setState({
      showLoading: true,
    });

    const files = [];

    function extractPersonFiles(p) {
      const fileId = files.length;
      if (p.kind === 'natural') {
        files.push(p.idFile[0]);
        return {
          ...p,
          idFile: fileId,
        };
      }
      files.push(p.kbisFile[0]);
      return {
        ...p,
        kbisFile: fileId,
      };
    }

    const author = extractPersonFiles(value.author);
    const clients = value.clients.map(extractPersonFiles);

    const contractFile = files.length;
    files.push(value.contractFile[0]);

    const data = JSON.stringify({
      contract: {
        ...pick(
          value,
          ['identifier', 'contractNumber', 'date', 'contractValue']
        ),
        author, clients, contractFile,
      },
      tokenId: token.id,
      test: global.__TEST__,
    });

    const formData = new FormData();
    formData.append('data', data);
    files.forEach(file => formData.append('files', file));

    fetch(`${WH_API_URL}act`, {
      method: 'POST',
      body: formData,
    })
      .then(res => {
        if (res.status === 201) {
          this.setState({
            showLoading: false,
            showSuccess: true,
          });
        } else {
          console.log('Server error', res.status);
          this.showServerError();
        }
      })
      .catch(err => {
        console.error('Fetch error', err.stack || err);
        this.showServerError();
      });
  }

  onResetClick = () => {
    this.setState({
      showSuccess: false,
    });
    store.dispatch(actions.reset('act'));
  }

  showServerError() {
    this.setState({
      showLoading: false,
    });
    store.dispatch(
      actions.setErrors(
        'act',
        { serverError: true }
      )
    );
  }

  renderForm() {
    return (
      <div>
        <div className={formStyles.bigTitle}>
          Formulaire
        </div>
        <Provider store={store}>
          <ActForm
            model="act"
            form="actForm"
            onSubmit={this.onSubmit}
          />
        </Provider>
      </div>
    );
  }

  renderSuccess() {
    return (
      <div>
        <div className={formStyles.bigTitle}>
          Confirmation
        </div>

        <div className={styles.confirmationBox}>
          <Icon
            className={styles.confirmationIcon}
            name="check"
          />

          <p className={styles.confirmationCongrats}>
            Félicitations !
          </p>

          <div className={styles.confirmationInfo}>
            <p>
              Votre contrat a bien été envoyé et sera contresigné sous 48h.
            </p>

            <p>
              Une copie certifiée conforme sera envoyée à chacune des parties dans les prochains jours.
            </p>

            <p>
              Vous recevrez également un email de confirmation à l’adresse que vous avez enregistrée.
            </p>
          </div>

          <button
            className={formStyles.submitButton}
            type="button"
            onClick={this.onResetClick}
          >
            Enregistrer un autre contrat
          </button>
        </div>
      </div>
    );
  }

  render() {
    const { showSuccess, showLoading } = this.state;

    let content = showSuccess ? this.renderSuccess() : this.renderForm();

    return (
      <div className={styles.app}>
        {showLoading &&
          <LoadingModal>
            Merci de bien vouloir patienter pendant le traitement de votre requête.
          </LoadingModal>
        }
        {content}
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./client/app/App.js
 **/